import { ActionTree } from "vuex";
import { RootState } from "../types";
import { SchoolState } from "./types";
import SchoolService from "@/services/school.service";
import { BaseAdmin } from "@/services/bases/base.service";
const service: SchoolService = new SchoolService();

export const actions: ActionTree<SchoolState, RootState> = {
    getNotification(_, params) {
        return BaseAdmin().get("admin-job-fair/landing/organizer/notification/get", params);
    },
};
